import { Pagination, PaginationContent, PaginationItem, PaginationPrevious, PaginationNext } from "./ui/pagination";
import { NUM } from "../lib/dashboardTokens";

// Plain "X–Y of Z" + Previous/Next — used by any table on this dashboard that's capped
// at a fixed page size instead of scrolling a long list.
export function TablePagination({ page, pageSize, total, onPageChange }) {
  const pageCount = Math.max(1, Math.ceil(total / pageSize));
  const start = total === 0 ? 0 : page * pageSize + 1;
  const end = Math.min(total, (page + 1) * pageSize);
  const canPrev = page > 0;
  const canNext = page < pageCount - 1;

  if (total <= pageSize) return null;

  return (
    <div className="mt-3 flex items-center justify-between gap-3 border-t border-slate-100 pt-3">
      <span className={`text-xs text-slate-500 ${NUM}`}>
        {start}–{end} of {total}
      </span>
      <Pagination className="mx-0 w-auto justify-end">
        <PaginationContent>
          <PaginationItem>
            <PaginationPrevious
              href="#"
              onClick={(e) => {
                e.preventDefault();
                if (canPrev) onPageChange(page - 1);
              }}
              className={!canPrev ? "pointer-events-none opacity-40" : "cursor-pointer"}
              data-testid="pagination-prev"
            />
          </PaginationItem>
          <PaginationItem>
            <span className={`px-2 text-xs text-slate-500 ${NUM}`}>
              {page + 1} / {pageCount}
            </span>
          </PaginationItem>
          <PaginationItem>
            <PaginationNext
              href="#"
              onClick={(e) => {
                e.preventDefault();
                if (canNext) onPageChange(page + 1);
              }}
              className={!canNext ? "pointer-events-none opacity-40" : "cursor-pointer"}
              data-testid="pagination-next"
            />
          </PaginationItem>
        </PaginationContent>
      </Pagination>
    </div>
  );
}
